module.exports = __webpack_public_path__ + "static/media/medical_cert_slider_phone1.c7d27526.png";